import { Check, Eye, X } from "lucide-react";
import { InlineActionButton } from "@/components/ui/InlineActionButton";

type ChangeRequestAlertActionsProps = {
  isBusy: boolean;
  onOpenTargetOrder: () => void;
  onApproveChangeRequest: () => void;
  onToggleReject: () => void;
};

export function ChangeRequestAlertActions({
  isBusy,
  onOpenTargetOrder,
  onApproveChangeRequest,
  onToggleReject,
}: ChangeRequestAlertActionsProps) {
  return (
    <>
      <InlineActionButton
        onClick={onOpenTargetOrder}
        icon={<Eye size={12} />}
      >
        Ver pedido
      </InlineActionButton>
      <InlineActionButton
        tone="success"
        onClick={onApproveChangeRequest}
        disabled={isBusy}
        icon={<Check size={12} />}
      >
        Aprovar
      </InlineActionButton>
      <InlineActionButton
        tone="danger"
        onClick={onToggleReject}
        disabled={isBusy}
        icon={<X size={12} />}
      >
        Recusar
      </InlineActionButton>
    </>
  );
}
